// 💾 src/hooks/useBinanceSocket.ts
import { useEffect, useRef, useState } from "react"

export type Trade = {
  price: string
  qty: string
  time: number
  isBuyerMaker: boolean
}

export type Depth = {
  bids: [string, string][]
  asks: [string, string][]
}

type StreamType = "trade" | "depth"

export const useBinanceSocket = (
  symbol: string,
  stream: StreamType,
  options: { limit?: number } = {}
) => {
  const [trades, setTrades] = useState<Trade[]>([])
  const [depth, setDepth] = useState<Depth>({ bids: [], asks: [] })
  const wsRef = useRef<WebSocket | null>(null)
  const limit = options.limit ?? 40

  useEffect(() => {
    if (!symbol || !stream) return

    const streamSymbol = symbol.replace("_", "").toLowerCase()
    const url =
      stream === "trade"
        ? `wss://stream.binance.com:9443/ws/${streamSymbol}@trade`
        : `wss://stream.binance.com:9443/ws/${streamSymbol}@depth10@100ms`

    const ws = new WebSocket(url)
    wsRef.current = ws

    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data)

        if (stream === "trade") {
          const newTrade: Trade = {
            price: data.p,
            qty: data.q,
            time: data.T,
            isBuyerMaker: data.m
          }
          setTrades((prev) => [newTrade, ...prev.slice(0, limit - 1)])
        } else if (stream === "depth") {
          setDepth({
            bids: data.bids || [],
            asks: data.asks || []
          })
        }
      } catch (err) {
        console.error("WS parse error", err)
      }
    }

    return () => {
      wsRef.current?.close()
    }
  }, [symbol, stream, limit])

  return stream === "trade" ? trades : depth
}
